import styled from 'styled-components';
import ListByDate from './ListByDate';
import { colorSchema } from 'utils/style';

export default styled(ListByDate)`
  .list-by-date {
    display: flex;
    flex-direction: column;
    width: 100%;

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 1.8rem;
      font-weight: bold;
    }
  }
`;
